(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('PeopleAssociateController', PeopleAssociateController)

    /** @ngInject */
    function PeopleAssociateController($timeout, LoadingHelper, PersonService, AuthenticationService,
        PreRegistraterService, sweetAlert, DEFAULT_IDENTIFIERS, SYSTEM_MODULES) {
        const vm = this;
        let loggedPersonAvailableCompanies;

        // First step
        vm.searchPerson = () => {
            LoadingHelper.startLoading('.loading-holder');

            PersonService
                .getByDocument(vm.searchPersonData.Document)
                .then(success => {
                    if (success)
                        initStepTwo(success);
                    else
                        initStepThree();
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        // Second step
        vm.getFoundPersonImagePath = () => {
            if (vm.foundPerson.Image)
                return ImagePathHelper.imageResizePath('person', vm.foundPerson.Id, vm.foundPerson.Image, 150, 150);

            return 'api/images/res/100/100/placeholder.jpg';
        }

        vm.associatePerson = isPreRegister => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá associar a pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    handlePersonAssociation(isPreRegister);
                }
            })
        }

        // Shared
        vm.resetPersonSearch = () => {
            vm.personCompanyAssociationData = [];
            vm.errorCantEditSelf = false;
            vm.noCompanyWithPermissions = false;
            vm.showStepOneData = true;
            vm.searchPersonData = {};
            vm.preRegisterPerson = null;
            vm.newUserData = {};
            vm.step = 1;
        }

        init();

        function initStepTwo(foundPerson) {
            const loggedUserId = AuthenticationService.getUser().Id;

            // Logged person can't edit his own relationships
            if (loggedUserId == foundPerson.Id) {
                vm.errorCantEditSelf = true;
                vm.showStepOneData = false;

                LoadingHelper.stopLoading('.loading-holder');
            } else {
                vm.hasCompaniesToAssociate = handleAssociationToLoggedUserCompanies(foundPerson);

                vm.step = 2;

                LoadingHelper.stopLoading('.loading-holder');
            }
        }

        function initStepThree() {
            vm.hasCompaniesToAssociate = handleAssociationToLoggedUserCompanies();
            vm.step = 3;
            LoadingHelper.stopLoading('.loading-holder');
        }

        function handleAssociationToLoggedUserCompanies(foundPerson) {
            let hasCompaniesToAssociate = false;

            // Check if person has any companies to be associated or if he is already associated to all companies owned by the logged user
            if (foundPerson && foundPerson.PersonCompanies.length) {
                for (let index = 0; index < loggedPersonAvailableCompanies.length; index++) {
                    const loggedPersonCompany = loggedPersonAvailableCompanies[index];

                    if (foundPerson.PersonCompanies.find(foundPersonCompany => (loggedPersonCompany.CompanyId == foundPersonCompany.CompanyId))) {
                        hasCompaniesToAssociate = false;
                    } else {
                        hasCompaniesToAssociate = true;
                    }
                }

            }
            // If the found person does not have any companies related to him the logged user can associate any company
            else {
                hasCompaniesToAssociate = true;
            }

            // If the found person is not already associated with all companies that the logged person has permission to handle people
            if (hasCompaniesToAssociate) {
                vm.foundPerson = foundPerson;
                vm.loggedPersonAvailableCompanies = loggedPersonAvailableCompanies;
            }

            return hasCompaniesToAssociate;
        }

        function handlePersonAssociation(isPreRegister) {
            let personCompanyData = vm.personCompanyAssociationData
                .filter((personAssociate) => (personAssociate.ResponsibilityId != null))
                .reduce((acc, cur) => {
                    let associationData;

                    if (isPreRegister) {
                        associationData = {
                            CompanyId: cur.CompanyId,
                            ResponsibilityId: cur.ResponsibilityId,
                            PermissionGroupId: cur.ResponsibilityId != 4 ? DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER : DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE
                        }
                    } else {
                        associationData = {
                            CompanyId: cur.CompanyId,
                            PersonId: vm.foundPerson.Id,
                            ResponsibilityId: cur.ResponsibilityId,
                            PermissionGroupId: cur.ResponsibilityId != 4 ? DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER : DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE
                        }
                    }

                    acc.push(associationData);

                    return acc;
                }, []);

            if (isPreRegister) {
                let preRegisterData = {
                    Name: vm.newUserData.Name,
                    Email: vm.newUserData.Email,
                    CreatorPersonId: vm.loggedUserData.Id,
                    PreRegister_Company: personCompanyData
                }

                PreRegistraterService
                    .createPreRegister(preRegisterData)
                    .then(success => {
                        vm.step = 5;
                        vm.preRegisterPerson = success;

                        LoadingHelper.stopLoading('.loading-holder');
                    }, error => {
                        // When the person already has a pre-register we don't let the user create a new one and inform him
                        if (error.status == 500) {
                            sweetAlert.swal({
                                title: 'Pessoa já possui pré-registro!',
                                text: 'Essa pessoa já possui um pré-registro em andamento, para realizar associação ela deve primeiro finalizar o cadastro.',
                                type: 'warning',
                                confirmButtonText: 'Ok',
                                showCancelButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then(() => {
                                $timeout(() => {
                                    vm.resetPersonSearch();
                                })
                            })
                        } else {
                            UtilHelper.errorCallback(error);
                        }

                        LoadingHelper.stopLoading('.loading-holder');
                    })
            } else {
                PersonService
                    .associateToCompany(personCompanyData)
                    .then(() => {
                        vm.step = 4;

                        LoadingHelper.stopLoading('.loading-holder');
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.loading-holder');
                    })
            }
        }

        function preInitValidation() {
            loggedPersonAvailableCompanies = AuthenticationService.getCompanyDataByPermissionGroupAndModuleId(vm.loggedUserData.PermissionGroup.Id, SYSTEM_MODULES.FRANCHISEE_PEOPLE);

            // Logged person does not have permission to handle person on any company
            if (!loggedPersonAvailableCompanies.length) {
                vm.noCompanyWithPermissions = true;
                vm.showStepOneData = false;
                vm.showStepOneData = false;
            } else {
                vm.showStepOneData = true;
                vm.noCompanyWithPermissions = false;
                vm.errorCantEditSelf = false;
            }
        }

        function init() {
            vm.loggedUserData = AuthenticationService.getUser();
            vm.personCompanyAssociationData = [];

            preInitValidation();

            vm.step = 1;
        }
    }
}());